export const API_BASE_URL =
  import.meta.env.MODE === 'cloud'
    ? 'https://cloud.activepieces.com'
    : window.location.origin;

export const API_URL = `${API_BASE_URL}/api`;

const unauthenticatedRoutes = [
  '/v1/managed-authn/external-token',
  '/v1/authentication/sign-in',
  '/v1/authentication/sign-up',
  '/v1/authentication/sign-in-with-google',
  '/v1/authentication/sign-in-with-kizeo',
  '/v1/authentication/sign-in-with-kuser',
  '/v1/authentication/current-kuser-info',
  '/v1/authentication/refresh',
  '/v1/authn/local/verify-email',
  '/v1/flags',
  '/v1/authn/federated/login',
  '/v1/authn/federated/claim',
  '/v1/otp',
  '/v1/human-input',
  '/v1/authn/local/reset-password',
  '/v1/user-invitations/accept',
  '/v1/internal-admin',
];

const refreshTokenExcludedRoutes = ['/v1/authentication/sign-out'];

export const isUnauthenticatedRoute = (url: string): boolean =>
  unauthenticatedRoutes.some((route) => url.startsWith(route));

export const isRefreshTokenExcludedRoute = (url: string): boolean =>
  refreshTokenExcludedRoutes.some((route) => url.startsWith(route));
